import { memo } from "react"
import { Navigate, Outlet } from "react-router-dom";
import Footer from "../../organisms/Footer";
import { SalesmanSidebar } from "../../organisms/sidebar/SalesmanSidebar";
import SalesmanHeader from "../../organisms/header/SalesmanHeader";
import Layout from "../Layout";


const SalesmanBase: React.FC = memo(() => {
  const token = localStorage.getItem('localJWT');
  if (!token) return <Navigate replace to="/salesman-login"/>;
  return (
    <Layout
      header={<SalesmanHeader />}
      nav={<SalesmanSidebar />}
      main={<Outlet />}
      footer={<Footer />}
    />
  );
});


export default SalesmanBase;
